import {
  LayoutDashboard, Briefcase, Users, ClipboardCheck, Video, Library, BarChart3, Settings,
} from "lucide-react";

export const ALL = ["super_admin", "recruiter", "hiring_manager"];
export const STAFF = ["super_admin", "recruiter"];
export const ADMIN = ["super_admin"];

export const ROLE_LABELS = {
  super_admin: "Super admin",
  recruiter: "Recruiter",
  hiring_manager: "Hiring manager",
};

export const MODULES = [
  { key: "dashboard", label: "Dashboard", path: "/app", icon: LayoutDashboard, group: "daily", roles: ALL,
    blurb: "Your hiring at a glance" },
  { key: "jobs", label: "Jobs", path: "/app/jobs", icon: Briefcase, group: "daily", roles: ALL,
    blurb: "Open roles and drafts" },
  { key: "candidates", label: "Candidates", path: "/app/candidates", icon: Users, group: "daily", roles: ALL,
    blurb: "Everyone who applied" },
  { key: "assessments", label: "Assessments", path: "/app/assessments", icon: ClipboardCheck, group: "pipeline",
    roles: ALL, blurb: "Personality and work samples" },
  { key: "interviews", label: "Interviews", path: "/app/interviews", icon: Video, group: "pipeline", roles: ALL,
    blurb: "AI interview results" },
  { key: "talent-pool", label: "Talent pool", path: "/app/talent-pool", icon: Library, group: "pipeline",
    roles: STAFF, blurb: "Past candidates worth a second look" },
  { key: "reports", label: "Reports", path: "/app/reports", icon: BarChart3, group: "pipeline", roles: ALL,
    blurb: "Funnel and fairness reports" },
  { key: "settings", label: "Settings", path: "/app/settings", icon: Settings, group: "bottom", roles: ADMIN,
    blurb: "Email, branding and users" },
];

export const canSee = (m, role) => m.roles.includes(role);
export const visibleModules = (role) => MODULES.filter((m) => canSee(m, role));
export const moduleByKey = (key) => MODULES.find((m) => m.key === key);

export function safeNext(next) {
  if (!next || !next.startsWith("/") || next.startsWith("//")) return "/app";
  return next;
}
